import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { company } from '../../../data/products';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </li>
        <li>
          <a href={`mailto:${company.email}`}>Support</a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;
